import { render, staticRenderFns } from "./DodChatTabs.vue?vue&type=template&id=3d6b38d0&scoped=true&"
import script from "./DodChatTabs.vue?vue&type=script&lang=js&"
export * from "./DodChatTabs.vue?vue&type=script&lang=js&"
import style0 from "./DodChatTabs.vue?vue&type=style&index=0&id=3d6b38d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b38d0",
  null
  
)

export default component.exports